import { DPOHAPI } from './DPOHAPI';
import axios from 'axios';
import { keywordMonthRaw } from '../../../interfaces/generic-entity.interface';
import {
    committeeMeetingLinkFormatter,
    twitterLinkFormatter,
} from '../../navigation/routers/external_routing';
import { bumperSuperList } from '../../../interfaces/bumper-types.interface';
import { mpBiography, mpSummary } from '../interface/dpoh-entity.interface';
import { Tweet } from '../../issue-dashboards/interface/issue-entity.interface';

// Base URL for accessing the DPOH
const baseURL = process.env.REACT_APP_API_BASE_URL;

const fetchOverview = async (dpohId: string, date: string) => {
    return DPOHAPI.fetchDPOHOverview(undefined, dpohId, date, false, false);
};

const fetchRecentLobbyingActivity = async (dpohId: string, date: string) => {
    return DPOHAPI.fetchDPOHRecentLobbyingActivity(undefined, dpohId, date, false, false);
};

const fetchTopSectors = async (dpohId: string, date: string) => {
    return DPOHAPI.fetchDPOHTopSectors(undefined, dpohId, date, false, false);
};

const fetchTopSubjects = async (dpohId: string, date: string) => {
    return DPOHAPI.fetchDPOHTopSubjects(undefined, dpohId, date, false, false);
};

const fetchTopFirms = async (dpohId: string, date: string) => {
    return DPOHAPI.fetchDPOHInternalExternalSplit(undefined, dpohId, date, false, false);
};

const fetchOrgActivity = async (dpohId: string, date: string) => {
    return DPOHAPI.fetchDPOHOrgActivity(undefined, dpohId, date, false, false);
};

// MP API

// Fetch MP summary
const fetchMPSummary = async (mpFullName: string, date: string | undefined): Promise<mpSummary> => {
    const nameSplit: string[] = mpFullName.split(' ');
    const first = nameSplit[0];
    const last = nameSplit[nameSplit.length - 1];

    const summary_response = await axios.get(
        `${baseURL}/parliament/house/members/${mpFullName}/summary?first=${first}&last=${last}&date=${date}`
    );
    const summary_data: mpSummary = summary_response.data;

    return summary_data;
};

// Fetch MP bio
const fetchMPBio = async (mpFullName: string, date: string | undefined): Promise<mpBiography> => {
    const nameSplit: string[] = mpFullName.split(' ');
    const first = nameSplit[0];
    const last = nameSplit[nameSplit.length - 1];

    const bio_response = await axios.get(
        `${baseURL}/parliament/house/members/${mpFullName}/bio?first=${first}&last=${last}&date=${date}`
    );
    const bio_data: mpBiography = bio_response.data;

    return bio_data;
};

// Fetch HANS meeting sentences from the given MP
const fetchMPHansSentences = async (
    mpFullName: string,
    date: string | undefined
): Promise<bumperSuperList[]> => {
    const nameSplit: string[] = mpFullName.split(' ');
    const first = nameSplit[0];
    const last = nameSplit[nameSplit.length - 1];

    const sentence_response = await axios.get(
        `${baseURL}/parliament/house/members/${mpFullName}/sentences?first=${first}&last=${last}&date=${date}`
    );
    const sentence_data: any[] = sentence_response.data;

    const sentence_list: any[] = sentence_data.map((entry: keywordMonthRaw) => {
        return {
            ...entry,
            title:
                entry.meetingNo &&
                entry.parliament &&
                entry.session &&
                entry.committee &&
                entry.committee !== 'HANS'
                    ? committeeMeetingLinkFormatter(
                          entry.committee,
                          entry.parliament,
                          entry.session,
                          entry.meetingNo,
                          entry.title
                              ? `${entry.committee} (Meeting ${entry.meetingNo} - ${entry.date}): ${entry.title} `
                              : `${entry.committee}: ${entry.date} - Meeting ${entry.meetingNo}`
                      )
                    : entry.title
                    ? `${entry.committee}: ${entry.title} (Meeting ${entry.meetingNo} - ${entry.date})`
                    : `${entry.committee}: ${entry.date} - Meeting ${entry.meetingNo}`,
            lists: entry.datasets,
        };
    });

    return sentence_list;
};

// Fetch tweets from the given MP
const fetchMPTweets = async (mpFullName: string, date: string | undefined): Promise<Tweet[]> => {
    const nameSplit: string[] = mpFullName.split(' ');
    const first = nameSplit[0];
    const last = nameSplit[nameSplit.length - 1];

    const response = await axios.get(
        `${baseURL}/parliament/house/members/${mpFullName}/tweets?first=${first}&last=${last}&date=${date}`
    );
    const data: any[] = response.data;
    const converted_data: Tweet[] = data.map((entry) => {
        return {
            ...entry,
            tweet: twitterLinkFormatter(entry),
        };
    });
    return converted_data;
};

export const OfficeHoldersAPI = {
    fetchOverview,
    fetchRecentLobbyingActivity,
    fetchTopSectors,
    fetchTopSubjects,
    fetchTopFirms,
    fetchOrgActivity,
    fetchMPSummary,
    fetchMPBio,
    fetchMPHansSentences,
    fetchMPTweets,
};
